var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoleto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 36,
    viewBox: "0 0 58 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3.58875V35.8875H0V0Z",
    fill: "#94979D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.71 0H35.8875V35.8875H28.71V0Z",
    fill: "#94979D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4763 0H43.0651V35.8875H39.4763V0Z",
    fill: "#94979D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6538 0H50.2426V35.8875H46.6538V0Z",
    fill: "#94979D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8313 0H57.42V35.8875H53.8313V0Z",
    fill: "#94979D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17749 0H17.9437V35.8875H7.17749V0Z",
    fill: "#94979D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5325 0H25.1212V35.8875H21.5325V0Z",
    fill: "#94979D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoleto);
export default __webpack_public_path__ + "static/media/boleto.1869484a059ec3a5da8067b474a04741.svg";
export { ForwardRef as ReactComponent };